import { useContext, useEffect, useRef, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useParams, useSearchParams } from 'react-router-dom';

import { RootTemplate } from '~/components/templates/RootTemplate';
import { useNavigate } from '~/components/utils/Navigation';
import { MultiSessionsContext, useAuth } from '~/lib/auth';

export const SwitchSessionRoute: React.FC = () => {
  const { sessionId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const multiSessionsContext = useContext(MultiSessionsContext);
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const isInitRef = useRef(false);
  useEffect(() => {
    if (isInitRef.current) {
      return;
    }
    isInitRef.current = true;

    if (!sessionId) {
      navigate('/', {
        replace: true,
      });

      return;
    }

    if (loading) {
      return;
    }

    setLoading(true);

    const isCurrentSession = multiSessionsContext.currentId === sessionId;
    multiSessionsContext.add({
      sessionId,
      isCurrent: true,
    });

    if (!isCurrentSession) {
      queryClient.clear();
    }

    void auth.switchSession(sessionId).then((credentials) => {
      navigate(searchParams.get('nextUrl') || '/', {
        appRegion: credentials?.region,
      });
    });
  }, [
    auth,
    multiSessionsContext,
    queryClient,
    sessionId,
    navigate,
    loading,
    searchParams,
  ]);

  return <RootTemplate>Switching session...</RootTemplate>;
};
